<template>
    <div class="h2sconcentration">
        <table>
            <tr>
                <td class="left">
                    <label >H<sub>2</sub>S {{type}}</label>
                </td>

                <td class="result">
                  <label >{{concentration}} {{units}}</label>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
export default {
  /* eslint-disable */
    name: 'h2sconcentration',
    props: {
        unit: String,
        triggerprop: Number,
        obj: Object
    },
    data: () => ({
        concentration: 0,
        units: "\u03BCmol",
        unitsh2s: [
            "\u03BCmol/L",
            "mm Hg",
            "mBar",
            "%",
            "ppm (vol/vol)",
            "ppm (mg/L)"
        ],
        type: "Concentration:"

    }),
    methods: {
        calculate() {
            var temp
            var pressure
            var sal
            var gasconc
            var conc
            if (this.obj.tempType === "Kelvin") {
                temp = Number(this.obj.temp) - 273.15
            } else {
                temp = Number(this.obj.temp)
            }
            pressure = Number(this.obj.pressure)
            sal = Number(this.obj.salinity)
            gasconc = Number(this.obj.gasConcentration)
            switch(this.unit) {
                case "\u03BCmol/L":
                    this.units = "\u03BCmol/L"
                    conc = this.umolL(temp, sal, pressure, gasconc)
                    this.type = "Concentration:"
                    break;
                case "%":
                    this.units = "%"
                    conc = this.saturation(temp, sal, pressure, gasconc)
                    this.type = "Concentration:"
                    break;
                case "ppm (vol/vol)":
                    this.units = "ppm (vol/vol)"
                    conc = this.ppm(temp, sal, pressure, gasconc)
                    this.type = "Concentration:"
                    break;
                case "ppm (mg/L)":
                    this.units = "ppm (mg/L)"
                    conc = this.ppmmgL(temp, sal, pressure, gasconc)
                    this.type = "Concentration:"
                    break;
                case "mBar":
                    this.units = "mBar"
                    conc = this.mBar(temp, sal, pressure, gasconc)
                    this.type = "Partial Pressure:"
                    break;
                case "mm Hg":
                    this.units = "mm Hg"
                    conc = this.mmHg(temp, sal, pressure, gasconc)
                    this.type = "Partial Pressure:"
                    break;
                default:
                    this.units = "N/A"
                    conc = 0
                    this.type = ""
                    break;
            }

            this.concentration = conc.toPrecision(6)
        },
        K(temp, sal){
          var T0 = 273.15
          var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
          var ptable = 1 * (1013.25 - p_sat)
          var constA1 = -41.056300000
          var constA2 = 66.400500000
          var constA3 = 15.106000000
          var constB1 = -0.605830000
          var constB2 = 0.379753000
          var constB3 = -0.602340000
          var absTemp = temp + T0
          var k = Math.exp(
                  constA1
                  + constA2 * (100 / absTemp)
                  + constA3 * Math.log(absTemp / 100)
                  + sal / 1000 * (constB1
                      + constB2 * (absTemp / 100)
                      + constB3 * Math.pow((absTemp / 100), 2))
              ) * 1000000
          return k/ptable
        },
        umolL(temp, sal, pressure, gasconc){
          switch(this.obj.unitIn){
            case "\u03BCmol/L":
              return gasconc
            case "ppm (mg/L)":
              return gasconc*1000/34.0809
            case "mm Hg":
              return gasconc/0.750061683*this.K(temp,sal)
            case "%":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              var partpres = (pressure - p_sat) * gasconc / 100
              return this.K(temp, sal)*partpres
            case "mBar":
              return this.K(temp, sal)*gasconc
            case "ppm (vol/vol)":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              var partpres = (pressure - p_sat) * gasconc / 1000000
              return this.K(temp, sal)*partpres
          }
        },
        mmHg(temp, sal, pressure, gasconc){
          switch(this.obj.unitIn){
            case "\u03BCmol/L":
              return gasconc/this.K(temp,sal)*0.750061683
            case "ppm (mg/L)":
              var conc =gasconc*1000/34.0809
              return conc/this.K(temp,sal)*0.750061683
            case "mm Hg":
              return gasconc
            case "%":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              var partpres = (pressure - p_sat) * gasconc / 100
              return partpres*0.750061683
            case "mBar":
              return gasconc * 0.750061683
            case "ppm (vol/vol)":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              var partpres = (pressure - p_sat) * gasconc / 1000000
              return partpres*0.750061683
          }
        },
        saturation(temp, sal, pressure, gasconc){
          switch(this.obj.unitIn){
            case "\u03BCmol/L":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              var partpres = gasconc/this.K(temp,sal)
              return partpres*100/(pressure - p_sat)
            case "ppm (mg/L)":
              var conc = gasconc * 1000 / 34.0809
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              var partpres = conc/this.K(temp,sal)
              return partpres*100/(pressure-p_sat)
            case "mm Hg":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              return (gasconc / 0.750061683) / (pressure - p_sat) * 100
            case "%":
              return gasconc
            case "mBar":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              return gasconc*100/(pressure - p_sat)
            case "ppm (vol/vol)":
              return gasconc/10000
          }
        },mBar(temp, sal, pressure, gasconc){
          switch(this.obj.unitIn){
            case "\u03BCmol/L":
              return gasconc/this.K(temp,sal)
            case "ppm (mg/L)":
              var conc =gasconc*1000/34.0809
              return conc/this.K(temp,sal)
            case "mm Hg":
              return gasconc/0.750061683
            case "%":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              var partpres = (pressure - p_sat) * gasconc / 100
              return partpres
            case "mBar":
              return gasconc
            case "ppm (vol/vol)":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              return (pressure - p_sat) * gasconc / 1000000
          }
        },ppm(temp, sal, pressure, gasconc){
          switch(this.obj.unitIn){
            case "\u03BCmol/L":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              var partpres = gasconc/this.K(temp,sal)
              return partpres*1000000/(pressure-p_sat)
            case "ppm (mg/L)":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              var conc = gasconc*100/34.0809
              var partpres = conc/this.K(temp,sal)
              return partpres*10000000/(pressure-p_sat)
            case "mm Hg":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              return gasconc/0.750061683*1000000/(pressure - p_sat)
            case "%":
              return gasconc*10000
            case "mBar":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              return gasconc*1000000/(pressure - p_sat)
            case "ppm (vol/vol)":
              return gasconc
          }
        },ppmmgL(temp, sal, pressure, gasconc){
          switch(this.obj.unitIn){
            case "\u03BCmol/L":
              return gasconc*34.0809/1000
            case "ppm (mg/L)":
              return gasconc
            case "mm Hg":
              var conc = gasconc/0.750061683*this.K(temp,sal)
              return conc*34.0809/1000
            case "%":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              var partpres = (pressure - p_sat) * gasconc / 100
              var conc = partpres*this.K(temp,sal)
              return conc*34.0809/1000
            case "mBar":
              var conc = gasconc*this.K(temp,sal)
              return conc*34.0809/1000
            case "ppm (vol/vol)":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              var partpres = (pressure - p_sat) * gasconc / 1000000
              var conc = partpres*this.K(temp,sal)
              return conc*34.0809/1000
          }
        }
    },
    mounted() {
        this.calculate()
    },
    watch: {
        triggerprop: function(newval, oldval) {
            this.calculate()
        }
    }
}
</script>
